var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col mx-auto"},[_c('HeaderBar',{attrs:{"simple":true,"showLogin":false,"showSignup":false}}),_c('AppMain',{staticClass:"bg-[#f6f5ff00]"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }